import React, { useState } from 'react';
import { TreeProvider } from '../../../components/treeStructure/treeContext';
import withUser from '../../../withUser';
import useOfferRole from '../../../hooks/useOfferRole';
import { canEditOfferItem } from '../../../components/users/utils/roles';
import WidgetsSection from './WidgetsSection';
import useWidgetsQuery from './hooks/useWidgetsQuery';

const WidgetsList = ({ cacheKey, args, refetchWidgets, setRefetchWidgets, setIsLoadingOfferItem, isLoadingOfferItem, offerIsDraft, ...restProps }) => {
  const collapseInitialValue = !!JSON.parse(sessionStorage.getItem('collapseWidgetIsOpen'));
  const [collapseIsOpen, setCollapseIsOpen] = useState(collapseInitialValue);

  const { widgets, isLoading, error, reFetch, setWidgets } = useWidgetsQuery({
    args,
    cacheKey,
    collapseIsOpen,
    refetchWidgets,
    setRefetchWidgets,
    setIsLoadingOfferItem
  });

  const { offerId, scope } = args;
  const { userIsAdmin, userIsOfferEditor } = useOfferRole(offerId);

  if (error) return <p>Erreur</p>;

  const userCanEditOffer = canEditOfferItem({
    userIsAdmin,
    userIsOfferEditor,
    scope,
    isDraft: offerIsDraft
  });

  const props = {
    args,
    widgets,
    setWidgets,
    setRefetchWidgets,
    reFetch,
    collapseIsOpen,
    setCollapseIsOpen,
    isLoading,
    isLoadingOfferItem,
    offerIsDraft,
    userCanEditOffer,
    ...restProps
  };

  return (
    <TreeProvider {...props} elements={widgets}>
      <WidgetsSection {...props}/>
    </TreeProvider>
  );
};

export default withUser(WidgetsList);
